<div class="position-relative">
    <div class="keen-slider" #sliderRef [ngClass]="{'overflow-visible': showOverflow}">
        <div
            class="keen-slider__slide text-center"
            [ngClass]="{'active' : gi === currentSlide}"
            *ngFor="let pg of tiles; let gi = index"
            (click)="currentSlide = gi">
            <a [href]="'/products/' + pg.slug"
               [routerLink]="['/products', pg.slug]">
                <img class="image-as-bg hover"
                     [src]="pg.imageUrl ? pg.imageUrl : 'https://api.ysprod.co.uk/cms/images/assets/no-image.png'"
                     [appScrset]="pg.imageUrl ? pg.imageUrl : 'https://api.ysprod.co.uk/cms/images/assets/no-image.png'"
                     [width]="310">
            </a>
            <div class="mt-4 mb-3">
                <a class="ff-spectral fs-6 fw-bold text-primary"
                   [href]="'/products/' + pg.slug"
                   [routerLink]="['/products', pg.slug]">{{pg.name}}</a>
            </div>
            <p class="text-primary op-8 type-description mb-4" [innerHTML]="pg.previewText"></p>
            <p class="d-flex justify-content-center align-items-center">
                <span class="small me-2">Prices from</span>
                <span class="fs-5 fw-bold me-2">
                    {{pg.pricesFrom | currency: 'GBP' : 'symbol' : '1.0-0'}}
                </span>
                <button (click)="toggleFavourite(pg.id)" class="d-inline-block btn-blank">
                    <svg-icon *ngIf="(favourites$ | async).indexOf(pg.id) < 0"
                              src="assets/images/icon-heart.svg"
                              [svgClass]="'product-details__favorite__svg'"></svg-icon>
                    <svg-icon *ngIf="(favourites$ | async).indexOf(pg.id) >= 0"
                              src="assets/images/icon-heart.svg"
                              [svgClass]="'product-details__favorite__svg--active'"></svg-icon>
                </button>
            </p>
            <a class="btn btn-wide btn-primary fw-bold"
               [href]="'/products/' + pg.slug"
               [routerLink]="['/products', pg.slug]">
                View the product
            </a>
        </div>
    </div>

    <div class="d-flex justify-content-center pt-5">
        <button
            (click)="slider.moveToSlideRelative(i)"
            *ngFor="let slide of dotHelper; let i = index"
            [class]="'dot ' + (i === currentSlide ? 'active' : '')"
        ></button>
    </div>
</div>

